import * as Enumerable from 'linq';

export class LetterAvatar {

    public static readonly colors = ['#1abc9c', '#16a085', '#f1c40f', '#f39c12', '#2ecc71', '#27ae60', '#e67e22', '#d35400', '#3498db', '#2980b9', '#e74c3c', '#c0392b', '#9b59b6', '#8e44ad', '#bdc3c7', '#34495e', '#2c3e50', '#95a5a6', '#7f8c8d', '#ec87bf', '#d870ad', '#f69785', '#9ba37e', '#b49255', '#b49255', '#a94136'];

    public static generate(window: Window, document: Document, name: string, size: number): string {
        name = name || '';
        size = size || 60;

        // const colors = [
        //   '#1abc9c',
        //   '#16a085',
        //   '#f1c40f',
        //   '#f39c12',
        //   '#2ecc71',
        //   '#27ae60',
        //   '#e67e22',
        //   '#d35400',
        //   '#3498db',
        //   '#2980b9',
        //   '#e74c3c',
        //   '#c0392b',
        //   '#9b59b6',
        //   '#8e44ad',
        //   '#bdc3c7',
        //   '#34495e',
        //   '#2c3e50',
        //   '#95a5a6',
        //   '#7f8c8d',
        //   '#ec87bf',
        //   '#d870ad',
        //   '#f69785',
        //   '#9ba37e',
        //   '#b49255',
        //   '#b49255',
        //   '#a94136'
        // ];

        const nameSplit = String(name)
            .toUpperCase()
            .split(' ');
        const initials: string =
            nameSplit.length === 1
                ? nameSplit[0] ? nameSplit[0].charAt(0) : '?'
                : nameSplit[0].charAt(0) + nameSplit[1].charAt(0);

        const charIndex: number = (initials === '?' ? 72 : initials.charCodeAt(0)) - 64;
        const colourIndex: number = charIndex % 20;

        if (window.devicePixelRatio) size = size * window.devicePixelRatio;

        let canvas: HTMLCanvasElement = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;

        const context: CanvasRenderingContext2D = canvas.getContext('2d');
        context.fillStyle = LetterAvatar.colors[colourIndex - 1];
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.font = Math.round(canvas.width / 2.5) + 'px Arial';
        context.textAlign = 'center';
        context.fillStyle = '#FFF';
        context.fillText(initials, size / 2, size / 1.5);

        const dataURI = canvas.toDataURL();
        canvas = null;

        return dataURI;
    }

    public static generateSvg(text: string, size: number = 60, includeTag = true): string {



        // const template = [
        //   '<svg xmlns="http://www.w3.org/2000/svg" height="' + size + '" width="' + size + '" style="border-radius:50%;background: ' + finalColor + '">',
        //   '<text text-anchor="middle" x="50%" y="50%" dy="0.35em" fill="white" font-size="' + textSize + '" font-family="' + font + '">' + text.toUpperCase() + '</text>',
        //   '</svg>'
        // ];

        const finalColor = this.generateAvatarColor(text);
        text = this.generateAvatarAbbreviation(text);

        const body = '<style>svg{ background-color: rgb(' + finalColor + '); } </style>' + '<text transform="translate(15 20)" text-anchor="middle" fill="white" font-size="12" font-family="Proxima Nova, proxima-nova, HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif">' + text.toUpperCase() + '</text > ';

        const template = includeTag
            ? '<svg xmlns="http://www.w3.org/2000/svg" height="30" width="30">' + body + '</svg>'
            : body;

        return template;
    }

    public static generateSvgMarker(text: string,): string {

        const finalColor = this.generateAvatarColor(text);
        text = this.generateAvatarAbbreviation(text);

        // <path id="Shape" d="M18,0C25.732,0 32,5.641 32,12.6C32,23.963 18,36 18,36C18,36 4,24.064 4,12.6C4,5.641 10.268,0 18,0Z" fill="white" stroke="black"/>

        return `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="50">
                    <path d="M35.5934 18.4227C35.5934 20.4228 34.9343 22.8571 33.8377 25.5089C32.7444 28.1527 31.2326 30.9741 29.5641 33.7371C26.2272 39.2628 22.2866 44.5171 19.8808 47.5906C18.9248 48.8033 17.1682 48.8031 16.2124 47.5902C13.8065 44.5167 9.86606 39.2625 6.52935 33.7371C4.86081 30.9741 3.34903 28.1527 2.2557 25.5089C1.15906 22.8571 0.5 20.4228 0.5 18.4227C0.5 8.5182 8.36923 0.5 18.0467 0.5C27.7242 0.5 35.5934 8.5182 35.5934 18.4227Z" fill="white" stroke="%23aaaaaa"/>
                    <circle id="Oval" cx="18" cy="18" r="14" style="fill:rgb(${finalColor});"/>
                    <text transform="translate(18 22)" text-anchor="middle" fill="white" font-size="11" font-family="Proxima Nova, proxima-nova, HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif">${text.toUpperCase()}</text > 
                </svg>`;
    }

    public static generateSvgMarkerDataUri(text: string) {

        const svg = LetterAvatar.generateSvgMarker(text);
        const prefix = 'data:image/svg+xml;utf8,';
        return `${prefix}${svg}`;
    }

    public static generateSvgCustom(text: string, backgroundColor: string, size: number = 60): string {

        if (!text)
            text = '??';

        const textSize = Math.ceil(size / 2.5);
        const font = 'Proxima Nova, proxima-nova, HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif';

        const template = [
            '<svg xmlns="http://www.w3.org/2000/svg" height="30" width="30">' +
            `<style>svg{ background-color: rgb(${this.hexToRgb(backgroundColor.replace('#', ''))}); } </style>` +
            '<text transform="translate(15 20)" text-anchor="middle" fill="white" font-size="12" font-family="Proxima Nova, proxima-nova, HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif">' + text.toUpperCase() + '</text > ' +
            '</svg>'
        ];

        return template.join('');
    }

    public static generateSvgCustomDataUri(text: string, backgroundColor: string, size: number = 60) {

        const svg = LetterAvatar.generateSvgCustom(text, backgroundColor, size);
        const prefix = 'data:image/svg+xml;utf8,';
        return `${prefix}${svg}`;
    }

    public static generateSvgDataUri(text: string, size: number = 60) {

        const svg = LetterAvatar.generateSvg(text, size);
        const prefix = 'data:image/svg+xml;utf8,';
        return `${prefix}${svg}`;
    }

    public static generateAvatarAbbreviation(text: string): string {
        if (!text)
            text = '??';

        // Ensure we have intials
        const split = text.split(' ');
        text = split.length > 0
            ? Enumerable
                .from(split)
                .select(x => x.trim())
                .where(x => x !== '' && x !== '&')
                .take(2)
                .select(x => x[0])
                .toArray()
                .join('')
            : text;

        return text;
    }

    public static generateAvatarColor(text: string) {

        const colorIndex = Math.floor((text?.charCodeAt(0) - 65) % LetterAvatar.colors.length);
        let hex = LetterAvatar.colors[Math.abs(colorIndex)];

        if (!hex) {
            hex = '#ffffff';
        }

        const finalColor = LetterAvatar.hexToRgb(hex.substring(1, hex.length));
        return finalColor;

    }

    public static hexToRgb(hex) {
        if (!hex) {
            return [0, 0, 0].join(",");
        }

        const bigint = parseInt(hex, 16);
        // tslint:disable-next-line:no-bitwise
        const r = (bigint >> 16) & 255;
        // tslint:disable-next-line:no-bitwise
        const g = (bigint >> 8) & 255;
        // tslint:disable-next-line:no-bitwise
        const b = bigint & 255;

        return [r, g, b].join(",");
    }
}
